module.exports = __webpack_public_path__ + "static/assets/b1ccb1d911886b973398e4c4d1a6bb91.png";